var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "course"
  }, [_c('ActivityGoodsList', {
    attrs: {
      "span": 8
    },
    on: {
      "select": _vm.selectActivity
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  })])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };